import { buildEndpoint } from './build-endpoint';
import type { Builder, EndpointsShape, EndpointsShapeWithNamespaces } from './create-api.model';
import { isNameSpacedEndpointShape } from './create-api.utils';
import { createApiHooks, createApiHooksForNamespacedEndpoints } from './create-api-hooks';
import type {
    ApiHookOptions,
    ApiHookOptionsForNamespacedEndpoints,
    ApiHooks,
    ApiHooksForNamespacedEndpoints,
} from './create-api-hooks/create-api-hooks.model';

// Overload signatures
function createApi<T extends EndpointsShape, O extends ApiHookOptions<T>>(
    buildEndpoints: Builder<T>,
    hookOptions?: O,
): T & ApiHooks<T, O>;

function createApi<T extends EndpointsShapeWithNamespaces>(
    buildEndpoints: Builder<T>,
    hookOptions?: ApiHookOptionsForNamespacedEndpoints<T>,
): T & ApiHooksForNamespacedEndpoints<T>;

/**
 * Create a standardized client-side API, with auto-generated query/mutation hooks.
 **/
function createApi<T extends EndpointsShape | EndpointsShapeWithNamespaces>(
    buildEndpoints: Builder<T>,
    hookOptions?: any,
): any {
    const endpoints = buildEndpoints(buildEndpoint);

    if (isNameSpacedEndpointShape(endpoints)) {
        const hooks = createApiHooksForNamespacedEndpoints(endpoints, hookOptions);

        return {
            ...endpoints,
            ...hooks,
        };
    } else {
        // V1 shape
        const hooks = createApiHooks(endpoints as EndpointsShape, hookOptions);
        return { ...endpoints, ...hooks };
    }
}

export { createApi };
